import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../../../environment';

const appRoutes: Routes = [
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: !environment.production, useHash: false }, // <-- debugging purposes only
    ),
  ],
  exports: [
    RouterModule,
  ],
})
export class RoutingModule {}



// WEBPACK FOOTER //
// ./src/app/common/routing/routing.module.ts